import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=a8dd5e52&scoped=true"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"
import style0 from "./subscription.vue?vue&type=style&index=0&id=a8dd5e52&prod&lang=scss&scoped=true"
import style1 from "./subscription.vue?vue&type=style&index=1&id=a8dd5e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dd5e52",
  null
  
)

export default component.exports